export const actionTypes = {
  login: 'LOGIN',
  create: 'CREATE',
  update: 'UPDATE',
  remove: 'REMOVE',
};

export const entityTypes = {
  admin: 'ADMIN',
  department: 'DEPARTMENT',
  log: 'LOG',
  project: 'PROJECT',
  settings: 'SETTINGS',
  weekends: 'WEEKENDS',
  worker: 'WORKER',
};

export const diffKinds = {
  edit: 'E',
  add: 'N',
  remove: 'D',
};
